// removed by extract-text-webpack-plugin
module.exports = {"menu":"src-components----Menu-module---menu---2fE1l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu.module.css
// module id = 125
// module chunks = 35783957827783 195351340454287